import React, { useEffect, useState } from 'react'
import TabMenu from '../components/companies/TabMenu'
import DynamicTable from '../components/Widgets/Global/DynamicTable'
import { fetchAllDocuments } from '../api/pocketbase';
import { useParams } from 'react-router-dom';

const DocumentsPage = () => {
  const [documents, setDocuments] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    fetchAllDocuments(id)
    .then(response => setDocuments((response || []).map((doc) => ({
      ...doc,
      signedDate: doc.signedDate ? new Date(doc.signedDate).toLocaleDateString() : "-"
    }))))
    .catch((error) => {
      throw new Error(error.message);
    })
  }, [id]);
  const tableSections = [
    { title: "Documents", data: documents || [] },
  ]
  const contractsColoumn = [
    {
      key : "id" , label : "Contract Reference" , type : "info"   
    },
    {
      key : "contractType" , label : "Contract Type" , type : "info"   
    },
    {
      key : "version" , label : "Issue Version" , type : "info"   
    },
    {
      key : "signedDate" , label : "Signed Date" , type : "info"   
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="space-y-6 px-3 py-4 sm:px-6 sm:py-6">
        <TabMenu />
        <div className="flex w-full flex-col gap-6">
          {tableSections.map((section, index) => (
            <div key={index} className="rounded-xl bg-white p-4 shadow-sm sm:p-6">
              <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="text-lg font-semibold text-gray-900">{section.title}</h2>
              </div>
              <DynamicTable
                columns={contractsColoumn}
                data={section.data}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default DocumentsPage